import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { MatiereForm } from '../components'
import { useMatiere, useCreateMatiere, useUpdateMatiere } from '../hooks/use-matieres'

export function MatiereFormPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isEdit = !!id

  const { data: matiere, isLoading } = useMatiere(id ? parseInt(id) : undefined)
  const createMatiere = useCreateMatiere()
  const updateMatiere = useUpdateMatiere()

  const handleSubmit = (data: { nom: string; codeMatiere: string; couleur?: string; estLangue: boolean }) => {
    if (isEdit) {
      updateMatiere.mutate(
        { id: parseInt(id!), data: { ...data, id: parseInt(id!) } },
        { onSuccess: () => navigate('/administration/matieres') },
      )
    } else {
      createMatiere.mutate(data, {
        onSuccess: () => navigate('/administration/matieres'),
      })
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  return (
    <div>
      <EntityPageHeader
        title={
          isEdit
            ? t('administration.sections.subjects.editTitle', 'Modifier la matière')
            : t('administration.sections.subjects.createTitle', 'Créer une matière')
        }
        backTo="/administration/matieres"
      />
      <MatiereForm
        matiere={matiere}
        onSubmit={handleSubmit}
        isPending={createMatiere.isPending || updateMatiere.isPending}
      />
    </div>
  )
}
